import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { essayOptions } from '../../student-portal/essay-pilot/essay-pilot.component';
import { EssayPilotService } from '../../services/essay-pilot/essay-pilot.service';
import { CommonModule } from '@angular/common';
import { Form, FormControl, FormGroup, FormsModule, NgModel, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CommanEssayQuestion } from '../../models/essay-pilot/commanEssayQuestion';
import { NgModule } from '@angular/core';
import { CommanEssayQuestionRequest } from '../../models/essay-pilot/commonEssayQuestionRequest';

@Component({
  selector: 'app-common-question',
  standalone: true,
  imports: [ButtonModule,InputTextModule, CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './common-question.component.html',
  styleUrl: './common-question.component.scss'
})
export class CommonQuestionComponent {

  commonQuestions: CommanEssayQuestion[] = [];
  isSubmitted: boolean = false;
  isLoading: boolean = false;
  questionText:string = '';
  

  constructor(private essayPilotService: EssayPilotService,
    private messageService: MessageService
  ){
    this.loadQuestions();
  }

  addNewQuestion(){
    const newQuestionRequest: CommanEssayQuestionRequest = {question: '', answerWordLimit: 50};
    this.isLoading = true;
    this.essayPilotService.addCommonEssayQuestion(newQuestionRequest).subscribe({
      next:( createdQuestion: CommanEssayQuestion) =>{
        this.commonQuestions.push(createdQuestion);
        this.isLoading = false
        this.loadQuestions();
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to add new question.' });
      }
    })
  }

  deleteQuestion(questionId: number){
    this.essayPilotService.deleteCommonEssayQuestion(questionId).subscribe({
      next:() =>{
        this.commonQuestions = this.commonQuestions.filter(question => question.id !== questionId);
        this.loadQuestions();
      },
      error: (error) =>{
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete question.' });
      }
    })
  }

  updateQuestion(question : CommanEssayQuestion){
    if( !question || !question.question ||question.question?.trim() === ''){
      return;
    }
    const updateRequest: CommanEssayQuestionRequest = {question: question.question, answerWordLimit: question.answerWordLimit};
    this.essayPilotService.updateCommonEssayQuestion(question.id, updateRequest).subscribe({
      next:(updatedQuestion: CommanEssayQuestion) =>{
        const index = this.commonQuestions.findIndex(q => q.id === updatedQuestion.id);
        this.commonQuestions[index] = updatedQuestion;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Question updated successfully.' });
      },
      error:(error) =>{
        console.warn(`Error while saving question: ${error}`);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update question.' });
      }
    })
    
  }

  loadQuestions() {
    this.isLoading = true;
    this.essayPilotService.getCommonEssayQuestions().subscribe({
      next: (response: any) => {
        this.commonQuestions = response.result;
        this.commonQuestions.forEach((question, index) => {
          this.isLoading = false;
        });
        
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load questions.' });
      }
    });
  }

}
